<div class="grid">
	<!-- ROW 1-->
	<div class="col-12">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-100">
				<div class="flex align-items-center justify-content-center">{{ 'CREATED_BY' | translate }}</div>
				<div class="flex align-items-center justify-content-center">
					<label>{{ ticket.UserFirstName + ' ' + ticket.UserLastName }}</label>
				</div>
		</div>
	</div>
	<!-- ROW 2-->
	<div class="col-12">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-100">
				<div class="flex align-items-center justify-content-center">{{ 'STATUS' | translate }}</div>
				<div class="flex align-items-center justify-content-center">
					<p-tag [value]="ticket.FlagClosed? ('CLOSED' | translate) : ('OPENED' | translate)"
						[severity]="ticket.FlagClosed? 'danger' : 'success'"></p-tag>
				</div>
		</div>
	</div>
	<!-- ROW 4-->
	<div class="col-12" *ngIf="ticket.ClosingDate">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-100">
				<div class="flex align-items-center justify-content-center">{{ 'CLOSED_ON' | translate }}</div>
				<div class="flex align-items-center justify-content-center">
					<label>{{ (ticket.ClosingDate | localizedDate: 'medium') }}</label>
				</div>
		</div>
	</div>
	<!-- ROW 5-->
	<div class="col-12">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-100">
				<div class="flex align-items-center justify-content-center">{{ 'TOTAL_ACCESS' | translate }}</div>
				<div class="flex align-items-center justify-content-center">
					<p-tag [value]="ticket.TotalAccess? ('YES' | translate) : ('NO' | translate)"
						[severity]="ticket.TotalAccess? 'primary' : 'secondary'"></p-tag>
				</div>
		</div>
	</div>
	<!-- ROW 6-->
	<div class="col-12" *ngIf="ticket.TotalAccessExpDate">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-100">
				<div class="flex align-items-center justify-content-center">{{ 'ACCESS_ENDS' | translate }}</div>
				<div class="flex align-items-center justify-content-center">
					<label>{{ (ticket.TotalAccessExpDate | localizedDate: 'medium') }}</label>
				</div>
		</div>
	</div>
	<!-- ROW 7-->
	<div class="col-12">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-100">
				<div class="flex align-items-center justify-content-center">{{ 'NOTE' | translate }}</div>
				<div class="flex align-items-center justify-content-center">
					<label>{{ ticket.Note | truncate:[220] }}</label>
				</div>
		</div>
	</div>
	<!-- ROW 9-->
	<div class="col-12" *ngIf="ticket.ClosingNote">
		<div class="flex justify-content-between flex-wrap border-bottom-1 border-100">
				<div class="flex align-items-center justify-content-center">{{ 'TECH_COMMENT' | translate }}</div>
				<div class="flex align-items-center justify-content-center">
					<label>{{ ticket.ClosingNote }}</label>
				</div>
		</div>
	</div>
</div>
